import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	getTagsForOrder,
	getTagsForPerson,
	selectTagsForOrder,
	selectTagsForPerson,
} from 'entities/tags';
import { getTimeslots } from 'entities/toolbar/timeslots';
import { formatWithLocale } from 'shared/lib/datepicker';
import { getPlaces } from 'entities/toolbar/places';
import { useLocation } from 'react-router-dom';
import { getHallmapResources } from 'entities/hallmap';
import { getSettings, selectSettingDefaultPerson } from 'entities/settings';
import { getPerson } from 'entities/person';
import axios from 'axios';
import { HTTP_HOST } from 'shared/consts/https';

export const useAppInit = () => {
	const dispatch = useAppDispatch();
	const tagsForOrder = useAppSelector(selectTagsForOrder);
	const tagsForPerson = useAppSelector(selectTagsForPerson);
	const defaultPersonId = useAppSelector(selectSettingDefaultPerson);

	const isInitApp = useRef(false);
	const { pathname } = useLocation();

	const refreshToken = async () => {
		const refresh = localStorage.getItem('refresh');

		if (!refresh) {
			window.location.pathname = '/login'
		}

		const response = await axios.post(
			`${HTTP_HOST}/api/token/refresh/`,
			{ refresh },
		);
		if (response) {
			localStorage.setItem('access', response.data.access);
		}
	}

	useEffect(() => {
		if (!isInitApp.current) {
			const loadApp = async () => {
				
				if (window.location.pathname === '/login') {
					isInitApp.current = true;

					return;
				}

				const response = await dispatch(getSettings())

				if(response?.type === 'getSettings/rejected') {
					return;
				}

				if (!tagsForPerson.length) {
					await dispatch(getTagsForPerson());
				}
	
				if (!tagsForOrder.length) {
					await dispatch(getTagsForOrder());
				}
	
				await dispatch(
					getTimeslots({
						date_slot: formatWithLocale(new Date(), 'yyyy-MM-dd'),
            selectNewSlotByDate: window.location.pathname !== '/',
					}),
				);
	
				await dispatch(getHallmapResources());
				await dispatch(getPlaces());

				setInterval(() => {
					refreshToken();
				}, 60_000)
			}

			loadApp();
		}

		isInitApp.current = true;
	}, [dispatch, pathname, tagsForOrder, tagsForPerson]);

	useEffect(() => {
		if (defaultPersonId != null) {
			dispatch(
				getPerson({
					id: defaultPersonId,
					isDefaultPerson: true,
				}),
			);
		}
	}, [dispatch, defaultPersonId]);

	return isInitApp.current;
};
